import React from "react";
import styled from "styled-components";
import PageSection from "../PageSection/PageSection";
import TagsContainer from "../TagsContainer/TagsContainer";

const Tags = styled(TagsContainer)`
	flex-grow: 1;
`;

const ContentWithTags = ({ tags, tagContentType, children, sectionPath }) => (
	<PageSection align="normal">
		{children}
		<Tags tags={tags} tagContentType={tagContentType} sectionPath={sectionPath} />
	</PageSection>);

export default ContentWithTags;
